import * as React from 'react';
import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../toolkit/uicomponent';
import { PopUpWrapperComponent } from '../popup/popupwrappercomponent';
import { BaseContext } from '../../../utils/basecontext';
import { LandingPageComponentHandler, LandingPageComponentProps, LandingPageComponentState } from './landingpagecomponent';
import { LandingPageCSSStyle } from './landingcss';
import { AlertType } from '../../toolkit/alert/alerttype';
import { AlertComponent } from '../../toolkit/alert/alertcomponent';
import { ImageLoaderComponent } from '../../toolkit/imageloader/imageloadercomponent';
import { LandingPageImageLoaderCSSStyleImpl } from './landingpageimageloadercss';
import { ImageLoaderCSSStyle } from '../../toolkit/imageloader/imageloadercss';
import { LandingPagePlayerWithSeekBarComponent } from '../../toolkit/player/landingpageplayer/landingpageplayerwithseekbarcomponent';
import { LandingPagePlayerCSSStyleImpl } from '../../toolkit/player/landingpageplayer/landingpageplayercss';
import { Strings } from '../../../utils/resources/strings';
import { ToneDto } from '../../../core/dto/tonedto';
import { MsisdnFloatingTextComponent } from '../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { CheckboxComponent } from '../../toolkit/checkbox/checkboxcomponent';
import { ButtonComponent } from '../../toolkit/button/buttoncomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { MSISDNValidation } from '../../toolkit/msisdnvalidation/msisdnvalidation';
import { SubscriptionPlanComponent } from '../popup/subscription_plan/subscriptionplancomponent';
import { Colors } from '../../../utils/resources/colors';
import { LandingErrorComponent } from './error/landingpageerrorcomponent';
import { FooterComponent } from '../../toolkit/footer-native/footercomponent';
import { OTPVerificationComponent } from '../popup/otpverification/otpverificationcomponent';
import { LoaderWrapperComponent } from '../popup/loaderwrappercomponent';
import { SendOTPDto, SendOTPDtoImpl } from '../../../core/dto/otp/sendotp/sendotpdto';
import { LoaderComponent } from '../../toolkit/loader/loadercomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';
import './landingpage-style.css';


export class LandingPageViewImpl extends UIComponentViewImpl<UIDataModel>
{
    playerComponent: LandingPagePlayerWithSeekBarComponent | null;
    checkboxComponent:CheckboxComponent;
    contactNumber:MsisdnFloatingTextComponent;
    loaderWrapperComponent:LoaderWrapperComponent;


    private popUpComponent: PopUpWrapperComponent;
    private imageLoaderCSSStyle :ImageLoaderCSSStyle;


    constructor(context:BaseContext, handler:UIComponentHandler)
    {
        super(context,handler);
        this.imageLoaderCSSStyle = new LandingPageImageLoaderCSSStyleImpl(context);
    }

    bindHandlers()
    {
        this.closePopup= this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.showToneOptionsPopup = this.showToneOptionsPopup.bind(this);
        this.showOTPView = this.showOTPView.bind(this);
    }

    draw(props: LandingPageComponentProps, state: LandingPageComponentState, cssStyle: LandingPageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("---buy tone: " + props.context.getResources().getString(Strings.buytone));

        return (
            <>
            {
                state.isError && <LandingErrorComponent context={props.context}/>}
            {
                !state.isError &&
                <>
                <div style={cssStyle.getWrapperCSSStyle()}>
                <div id="header-wrapper-landing" style={{borderBottom: "1px solid " + this.getContext().getResources().getColor(Colors.color_3),}}>
                    <div id="logo-wrapper" >
                            <img id="logo-img"  style={{}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                    </div>
                        <div id="lang-wrapper" style={{}}>
                            <label>{this.getUIProps().context.getUserContext().getLanguage() === LanguageConst.FRENCH ? LanguageConst.FRENCH : props.context.getResources().getString(Strings.arabic)}</label>
                        </div>
                </div>
                <div id="preview-wrapper" style={{}}>
                      <div id="preview-main" style={{}}>
                           <div id="preview-div" style={{}}/>
                                    <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={state.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/>

                               
                            <div id="tone-details-div" style={cssStyle.getToneDetailsDivCSSStyle()}>
                                <div id="tonename-div" style={cssStyle.getToneNameCSSStyle()}>{state.toneDto.getToneName()}</div>
                                <div id="artistname-div" style={cssStyle.getArtistNameCSSStyle()}>{state.toneDto.getArtistName()}</div>
                                <LandingPagePlayerWithSeekBarComponent ref={(item: any)=>{this.playerComponent = item;}} playIconName={"play_pink.svg"} pauseIconName={"pause_pink.svg"} playerCSSStyle={new LandingPagePlayerCSSStyleImpl(props.context)} isPlaying={false} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} context={props.context} />

                            </div>

                      </div>
                      <div id="buy-tone-wrapper" style={{}}>
                          {
                              !state.isSuccess &&
                              <div id="buy-tone-main" >
                              {props.context.getResources().getString(Strings.buytone)}
                              </div>
                          }
                           {
                              state.isSuccess &&
                              <div id="buy-tone-main" >
                                    {props.context.getResources().getString(Strings.your_order_is_successfully_completed)}
                              </div>
                          }
                                <div style={{width:"100%",height:'55px'}}>
                                    <div id="buy-tonename-div" style={{}}>{state.toneDto.getToneName()}</div>
                                    {/* <div style={cssStyle.getArtistNameCSSStyle()}>{"hgfdfghjk"}</div> */}
                                    <div id="buy-artistname-div" style={{}}>{state.toneDto.getArtistName()}</div>
                                
                                <div id="tone-details-col" style={{}}>
                                        <div id="heart-div" style={{}}>
                                            <img style={{cursor:"auto"}} id="heart-img" width="100%"  height="100%" src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                                            <div id="like-count" style={{cursor:"auto"}}>
                                            {this.getLikeCount(state.toneDto) + " " + this.getUIProps().context.getResources().getString(Strings.likes)}
                                            </div>
                                        </div>
                                        <div id="tune-charge-col" style={{}}/>
                                         <div id="tune-charge-div" style={{}}>
                                                <div id="tune-charge-label" style={{}}>{this.getContext().getResources().getString(Strings.tune_charge)}</div>
                                                <label id="tune-charge-content" style={{}}>{state.price}</label>
                                         </div>
                                         <div id="validity-details-col" style={{}}/>
                                            <div id="validity-details-div" style={{}}>
                                                    <div id="validity-label" style={{}}>{this.getContext().getResources().getString(Strings.absolute_validity)}</div>
                                                    <label id="validity-content" style={{}}>{state.toneDto.getExpirydate()}</label>
                                            </div>
                                         </div> 
                                         <div id="msisdn-div" style={{}}>
                                            <MsisdnFloatingTextComponent isDisabled={true}  maxLength={this.getContext().getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber = item;}} id={"#contactNumber"} value={this.getContext().getUserContext().getMsisdn()} inputType={"number"} isRequired={false} placeholder={this.getContext().getResources().getString(Strings.mobilenumber)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.numberIncorrect)}/>
                                         </div>
                                         {/* <div style={cssStyle.getRowDivCSSStyle()}>
                                            <CheckboxComponent ref={(item: any) => this.checkboxComponent = item} style={new CheckboxCSSStyleImpl(props.context)} onChange={() => {}} context={props.context} isChecked={props.context.getUserContext().getIsRememberMe()}/>
                                            <div style={cssStyle.getTermsConditionCSSStyle()}>
                                                <label>
                                                    {props.context.getResources().getString(Strings.terms_condition)}

                                                </label>
                                            </div>
                                        </div> */}

                                        <div style={cssStyle.getRowDivCSSStyle()}>
                                            <div id="button-div" style={{width:"180px",height:"40px",marginTop:"50px"}}>
                                                <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                                            </div>
                                        </div>
                                       {
                                           state.isSuccess &&
                                           <div id="explore-div" style={{width:"100%",height:'25px',marginTop:"25px",lineHeight:'25px',color:'#003187',fontSize:"18px"}}>
                                           <a target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("AboutAPPURL")}><label >{props.context.getResources().getString(Strings.explore_more_tunes)}</label></a>
                                           </div>
                                       }
                                       

                                 </div>
                                
                                {/* <div style={{width:"100%",height:'40px',}}>
                                    <div style={{marginTop:'50px'}}>
                                        <MsisdnFloatingTextComponent ref={(item: any) => this.contactNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                                    </div>
                                </div> */}
                      </div>
                      
                </div>
               <div style={{width:"100%",}}>
                    <FooterComponent context={this.getUIProps().context}/>

               </div>
                  
            </div>
       
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
             
           
        </>
        }
            </>
        );
    }

    onConfirmClick():void
    {
        (this.getUIComponentHandler() as LandingPageComponentHandler).onConfirmClick();
    }

   
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getLikeCount(toneDto: ToneDto): string
    {
        return toneDto.getLikeCount() === undefined ? "0" : toneDto.getLikeCount();
        // let formattedCount = this.getContext().getResources().getString(Strings.zero);

        // if(toneDto.getLikeCount() !== undefined)
        // {      
        //     if(+toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = toneDto.getLikeCount();
        //     }
        //     else if(+toneDto.getLikeCount() >= +this.getContext().getResources().getString(Strings.thousand) && +toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.thousand)) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.million)) + this.getContext().getResources().getString(Strings.M);
        //     }

        //     return formattedCount.replace("."+ this.getContext().getResources().getString(Strings.zero), "");
        // }
        // else
        // {
        //     return formattedCount;
        // }
    }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    validate(): boolean
    {
        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
                let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
                let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

    
                if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
                {
                    this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                    return false;
                }
               
                
                return true;   
            }
            return false; 
        }
    showPopup(id: string, msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
             
            this.popUpComponent !== null &&   this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={()=>''} context={this.getUIProps().context}/>);

         }
        
         else 
         {
            this.popUpComponent !== null &&  this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

         }
         
    }

    showOTPView()
    {
        this.popUpComponent !== null &&  this.popUpComponent.setShowWindow(true,
            <OTPVerificationComponent toneDto={(this.getUIState() as LandingPageComponentState).toneDto} id={this.getUIProps().context.getResources().getString(Strings.buy_now)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
    }
    getOTPData(): SendOTPDto
    {
        let request = new SendOTPDtoImpl();
        request.setMsisdn(this.getContext().getUserContext().getMsisdn());

        return request;
    }
    showToneOptionsPopup(id:string):void
    {
       this.playerComponent !== null && this.playerComponent !== undefined && this.playerComponent.onStopClicked();
      
      if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" + 
       this.getUIProps().context.getResources().getString(Strings.subscription))
       {
           this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
               <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={(this.getUIState() as LandingPageComponentState).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
       }
    }
    
    onPlayComplete(): void 
    {
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }

    onPlayStop(): void {
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    private onPlayClicked(): void
    {
        if(this.playerComponent !== null)
        {
            this.getContext().getPlayerManager().startPlay(
                (this.getUIState() as LandingPageComponentState).toneDto.getToneUrl(), this);
                // this.getContext().getPlayerManager().getAudioPlayer().getAudio();
        }
    }

    
    private onStopClicked(): void
    {
        this.getContext().getPlayerManager().stopPlay();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingview.tsx